import {
    addDays,
    EachDayOfIntervalResult,
    eachDayOfInterval,
    isMonday,
    isSunday,
    lastDayOfMonth,
    nextSunday,
    previousMonday,
    subDays,
} from "date-fns";

export function getCalendarConfig(
    year: number,
    month: number,
): {
    days: EachDayOfIntervalResult<
        {
            start: Date;
            end: Date;
        },
        undefined
    >;
    nextMonth: Date;
    prefMonth: Date;
    firstOfMonth: Date;
    firstMonday: Date;
    lastSunday: Date;
} {
    const firstOfMonth = new Date(year, month, 1, 0, 0);
    const firstMonday = isMonday(firstOfMonth) ? firstOfMonth : previousMonday(firstOfMonth);
    const lastOfMonth = lastDayOfMonth(firstOfMonth);
    const lastSunday = isSunday(lastOfMonth) ? lastOfMonth : nextSunday(lastOfMonth);
    const days = eachDayOfInterval({ start: firstMonday, end: lastSunday });
    const nextMonth = addDays(lastOfMonth, 1);
    const prefMonth = subDays(firstOfMonth, 1);

    return {
        days,
        nextMonth,
        prefMonth,
        firstOfMonth,
        firstMonday,
        lastSunday,
    };
}
